import Drawer from './drawer.vue';

export default Drawer;


// WEBPACK FOOTER //
// ./src/components/drawer/index.js